import { Outlet, Link, useLocation } from "react-router-dom";
import { profile } from "../data/site";

const navLinks = [
  { to: "/apps", label: "Apps" },
  { to: "/blogs", label: "Blog" },
];

export default function Layout() {
  const { pathname } = useLocation();

  return (
    <div className="mx-auto flex min-h-screen max-w-2xl flex-col px-6 lg:max-w-3xl">
      <header className="relative z-10 flex items-center justify-end py-8">
        <nav className="flex items-center gap-6">
          {navLinks.map((l) => {
            const active = pathname.startsWith(l.to);
            return (
              <Link
                key={l.to}
                to={l.to}
                className={`relative text-sm font-medium transition-colors ${active
                  ? "text-foreground"
                  : "text-muted-foreground hover:text-foreground"
                  }`}
              >
                {l.label}
                {active && (
                  <span className="absolute -bottom-1.5 left-0 h-px w-full bg-primary/60" />
                )}
              </Link>
            );
          })}
        </nav>
      </header>

      <main className="relative flex-1">
        <Outlet />
      </main>

      <footer className="relative z-10 border-t border-border/50 py-10">
        <div className="flex items-center justify-between">
          <p className="text-xs text-muted-foreground/60">
            &copy; {new Date().getFullYear()} {profile.name}
          </p>
          <div className="flex items-center gap-4">
            {profile.socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-muted-foreground/50 transition-colors hover:text-primary"
              >
                {s.label}
              </a>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
}
